import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/public/SEO";

export default function AnsiklopediHubPage() {
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCat, setActiveCat] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const [a, c] = await Promise.all([
          api.get(`/articles?lang=tr&type=encyclopedia&page_size=100${activeCat ? `&category=${activeCat}` : ""}`),
          api.get("/categories?type=encyclopedia"),
        ]);
        setItems(a.data.items || []);
        setCats(c.data || []);
      } finally { setLoading(false); }
    })();
  }, [activeCat]);

  // group by category for display
  const byCat = {};
  for (const a of items) {
    const cid = a.category_id || "_";
    if (!byCat[cid]) byCat[cid] = [];
    byCat[cid].push(a);
  }

  return (
    <>
      <SEO
        title="Kapadokya Ansiklopedisi"
        description="Vadiler, yerleşimler, tarih, gastronomi, şarapçılık, kaya kiliseleri, yeraltı şehirleri ve daha fazlası — Kapadokya'nın editör kalemiyle hazırlanmış kapsamlı referans kaynağı."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Kapadokya Ansiklopedisi",
          description: "Kapadokya hakkında her şey için kapsamlı bilgi bankası",
        }}
      />

      {/* Hero */}
      <section className="pt-40 pb-12 max-w-7xl mx-auto px-6 md:px-12" data-testid="ansiklopedi-header">
        <div className="text-[10px] tracking-[0.28em] uppercase text-cc-sepia mb-5">Referans Kaynağı</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-[5.5rem] text-cc-text leading-[1.02] mb-8">
          Kapadokya<br/><span className="italic">Ansiklopedisi.</span>
        </h1>
        <p className="max-w-2xl text-cc-muted text-lg leading-[1.85]">
          Vadiler, yerleşimler, kaya kiliseleri, yeraltı şehirleri, gastronomi, şarapçılık ve sözlük —
          Kapadokya hakkında bilmek istediğiniz her şey için bilgi bankası.
        </p>
      </section>

      {/* Category filter */}
      {cats.length > 0 && (
        <section className="max-w-7xl mx-auto px-6 md:px-12 pb-8 border-t border-cc-border pt-8" data-testid="ansiklopedi-cats">
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
            <button
              onClick={() => setActiveCat("")}
              className={`text-xs tracking-[0.22em] uppercase transition ${!activeCat ? "text-cc-sepia" : "text-cc-muted hover:text-cc-text"}`}
            >Tümü</button>
            {cats.map((c) => (
              <button key={c.id}
                onClick={() => setActiveCat(c.translations?.tr?.slug)}
                className={`text-xs tracking-[0.22em] uppercase transition ${activeCat === c.translations?.tr?.slug ? "text-cc-sepia" : "text-cc-muted hover:text-cc-text"}`}
              >{c.translations?.tr?.name}</button>
            ))}
          </div>
        </section>
      )}

      {/* Grouped grid */}
      <section className="py-12 md:py-20 max-w-7xl mx-auto px-6 md:px-12 pb-32" data-testid="ansiklopedi-grid">
        {loading ? <p className="text-cc-muted">Yükleniyor…</p> :
          cats.filter((c) => byCat[c.id]?.length).map((cat) => (
            <div key={cat.id} className="mb-20">
              <div className="flex items-end justify-between mb-8 border-b border-cc-border pb-4">
                <h2 className="font-serif text-3xl md:text-4xl text-cc-text">{cat.translations?.tr?.name}</h2>
                <span className="text-[10px] tracking-[0.22em] uppercase text-cc-muted">{byCat[cat.id]?.length} giriş</span>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-8">
                {byCat[cat.id]?.map((a) => (
                  <Link key={a.id} to={`/kapadokya-ansiklopedisi/${a.translations?.tr?.slug}`}
                        className="group block">
                    <div className="font-serif text-xl text-cc-text group-hover:text-cc-sepia transition mb-1">
                      {a.translations?.tr?.title}
                    </div>
                    <p className="text-sm text-cc-muted leading-snug line-clamp-2">
                      {a.translations?.tr?.excerpt}
                    </p>
                  </Link>
                ))}
              </div>
            </div>
          ))}
      </section>
    </>
  );
}
